import { render } from "./StepIdentity.vue?vue&type=template&id=3035f432"
import script from "./StepIdentity.vue?vue&type=script&lang=js"
export * from "./StepIdentity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__